<template>
    <div class="admin-page">
        <h3>انتخاب بنر ها</h3>     
        <div class="admin-form mt-4">
            <table>
                <tr>
                    <th>ID</th>
                    <th>نام</th>
                    <th class="half-width">تصویر</th>
                    <th>لینک</th>
                    <th>ابزار</th>
                </tr>
                <show-banner @editMe="editBanner" v-for="(b,i) in banners" :key="i" :theBanner="b"></show-banner>
            </table>
        </div>
    </div>    
</template>
<script>
import {ref,computed,inject,onMounted} from "@vue/composition-api"
import Service from "../../../utils/admin-service"
import ShowBanner from "./partials/OneBanner"
// import {useRoute} from "vue-router"
export default {
    components:{
        ShowBanner
    },
    setup(props,context){
        // component
        const global = inject('global')
        const errorHandler = (server,error) => {
            global.alertToggle('درخواست نا موفق!')
        }
        const theService = computed(()=>{
            return Service(false)
        })
        const banners = ref([])
        onMounted(()=>{
            theService.value.receive('admin/base-image',{},(s,d)=>{
                d.data.map((x)=>{
                    x.link = {value:x.link,valid:true}
                })
                banners.value = d.data
            },errorHandler)
        })
        const editBanner = (v) => {
            let f =new FormData()
            console.log("this is it",v)
            if(v.editPic){
                f.append('image',v.image)
            }
            if(v.editLink){
                f.append('link',v.link.value)
            }
            theService.value.transmit('admin/base-image/'+v.id,f,(s,d)=>{
                global.alertToggle('با موفقیت افزوده شد')
            },errorHandler)
        }
        return {banners,editBanner}
    }
}
</script>
<style scoped>
.admin-page{
    padding:2rem 5rem 2rem 5rem;
}

.admin-tab-bar{
    background-color: #fff;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
}

.admin-tab-bar .active{
    background-color: rgba(127, 127, 127, 0.1);
}

.admin-form{
    border-radius: 8px;
    background-color: rgba(127, 127, 127, 0.1);
    border:1px solid rgba(127, 127, 127, 0.2);
    min-height: 70vh;
}
.admin-tab-button{
    display: inline-block;
    min-width:10%;
    padding-top:1rem;
    margin-left: 3rem;
    padding-right: 1rem;
    padding-left: 1rem;
    text-align: center;
}

.admin-tab{
    padding:1.5rem 2rem 1.5rem 2rem;
    border-bottom: 1px solid rgba(127, 127, 127, 0.3);
    min-height: 50vh;
}

.adminSend{
    padding:1.5rem 2rem 1.5rem 2rem;
    text-align: left;
}


.admin-tab-button:hover{
    cursor: pointer;
}

.admin-locker{
    width: 15%;
    margin:1rem;
    border:2px dashed #9147FF;
    padding:0.3rem;
}

.admin-locker img{
    width: 100%;
}

th{
    text-align: center;
}
</style>